import React, { useState, useRef } from "react";
import {parseExcelFile} from "./excelParser";


const FileUpload = ({ onFileUploaded }) => {
  const [file, setFile] = useState(null);
  const [error, setError] = useState(null);
  const fileInputRef = useRef(null);

  const handleFileChange = async (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) await processFile(selectedFile);
  };

  const processFile = async (selectedFile) => {
    setError(null);

    const validExtensions = [".xlsx", ".xls", ".csv"];
    const ext = selectedFile.name.slice(selectedFile.name.lastIndexOf(".")).toLowerCase();

    if (!validExtensions.includes(ext)) {
      setError("Invalid file type. Only Excel (.xlsx, .xls) or CSV files allowed.");
      return;
    }

    if (selectedFile.size > 10 * 1024 * 1024) {
      setError("File size exceeds 10MB limit.");
      return;
    }

    try {
      const parsed = await parseExcelFile(selectedFile);

      if (!parsed.headers?.length) {
        setError("No headers found in the file.");
        return;
      }

      if (!parsed.data?.length) {
        setError("No rows of data found in the file.");
        return;
      }

      setFile(selectedFile);
      onFileUploaded({
        fileName: selectedFile.name,
        headers: parsed.headers,
        data: parsed.data,
      });
    } catch (err) {
      console.error("Parsing error:", err);
      setError("Failed to parse the file. Please ensure it's a valid Excel or CSV.");
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFile = e.dataTransfer.files[0];
    if (droppedFile) processFile(droppedFile);
  };

  return (
    <div className="p-6 border rounded bg-white shadow-md max-w-xl mx-auto">
      <h2 className="text-lg font-semibold mb-4">Upload Excel File</h2>

      <div
        className="border-2 border-dashed border-gray-300 p-6 text-center cursor-pointer rounded hover:border-blue-400 transition"
        onClick={() => fileInputRef.current?.click()}
        onDragOver={(e) => e.preventDefault()}
        onDrop={handleDrop}
      >
        <p className="text-gray-600">Click or drag a file here to upload</p>
        <input
          type="file"
          accept=".xlsx,.xls,.csv"
          hidden
          ref={fileInputRef}
          onChange={handleFileChange}
        />
      </div>

      {error && <p className="text-red-600 mt-4 text-sm">{error}</p>}

      {file && (
        <div className="mt-4 p-3 bg-green-50 text-sm rounded border border-green-200">
          <strong>{file.name}</strong> — {(file.size / 1024 / 1024).toFixed(2)} MB
        </div>
      )}
    </div>
  );
};

export default FileUpload;